import Vue from 'vue'

import Qs from 'qs'

class Clients {
  async suggest() {
    return await Vue.axios
      .get('app/clients/suggest')
  }

  async index({params}) {
    return await Vue.axios
      .get('app/clients', {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async create({data}) {
    return await Vue.axios
      .post('app/clients', data)
  }

  async read({id}) {
    return await Vue.axios
      .get('app/clients/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/clients/' + id, data)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/clients/' + id)
  }
}

const clients = new Clients()

export default clients
